import React from 'react'

const Zoom = () => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3290_53405)'>
        <path
          d='M47.3996 16.4632C46.0949 8.33977 39.6601 1.90515 31.5368 0.600441C29.0829 0.206353 26.5663 0 24 0C21.4337 0 18.9171 0.206287 16.4632 0.600441C8.33983 1.90515 1.90514 8.33977 0.600431 16.4632C0.206343 18.917 0 21.4336 0 24C0 26.5664 0.206277 29.083 0.600431 31.5368C1.90514 39.6602 8.3399 46.0948 16.4632 47.3996C18.9171 47.7936 21.4337 48 24 48C26.5663 48 29.0829 47.7937 31.5368 47.3996C39.6602 46.0948 46.0949 39.6602 47.3996 31.5368C47.7937 29.083 48 26.5664 48 24C48 21.4336 47.7937 18.917 47.3996 16.4632Z'
          fill='url(#paint0_linear_3290_53405)'
        />
        <path
          d='M14.3322 27.6803H8.37935C7.96168 27.6803 7.58852 27.4309 7.42869 27.0451C7.26886 26.6592 7.35642 26.219 7.65177 25.9237L11.7751 21.8004H8.81984C8.00799 21.8004 7.34986 21.1422 7.34986 20.3304H12.8397C13.2573 20.3304 13.6305 20.5797 13.7903 20.9655C13.9502 21.3514 13.8627 21.7915 13.5674 22.087L9.44404 26.2103H12.8622C13.6741 26.2103 14.3322 26.8684 14.3322 27.6803ZM40.6448 23.0866C40.6448 21.506 39.3589 20.2202 37.7784 20.2202C36.9329 20.2202 36.172 20.5883 35.6469 21.1724C35.1218 20.5883 34.3609 20.2202 33.5154 20.2202C31.9349 20.2202 30.649 21.506 30.649 23.0866V27.6803C31.4608 27.6803 32.119 27.0222 32.119 26.2103V23.0866C32.119 22.3166 32.7454 21.6901 33.5154 21.6901C34.2854 21.6901 34.9119 22.3166 34.9119 23.0866V26.2103C34.9119 27.0222 35.57 27.6803 36.3819 27.6803V23.0866C36.3819 22.3166 37.0083 21.6901 37.7784 21.6901C38.5484 21.6901 39.1748 22.3166 39.1748 23.0866V26.2103C39.1748 27.0222 39.833 27.6803 40.6448 27.6803V23.0866ZM29.914 24.0053C29.914 26.0958 28.2193 27.7905 26.1288 27.7905C24.0383 27.7905 22.3436 26.0958 22.3436 24.0053C22.3436 21.9148 24.0383 20.2202 26.1288 20.2202C28.2193 20.2202 29.914 21.9148 29.914 24.0053ZM28.444 24.0053C28.444 22.7267 27.4074 21.6901 26.1288 21.6901C24.8501 21.6901 23.8136 22.7267 23.8136 24.0053C23.8136 25.284 24.8501 26.3206 26.1288 26.3206C27.4074 26.3206 28.444 25.284 28.444 24.0053ZM21.7556 24.0053C21.7556 26.0958 20.0609 27.7905 17.9704 27.7905C15.8799 27.7905 14.1852 26.0958 14.1852 24.0053C14.1852 21.9148 15.8799 20.2202 17.9704 20.2202C20.0609 20.2202 21.7556 21.9148 21.7556 24.0053ZM20.2856 24.0053C20.2856 22.7267 19.2491 21.6901 17.9704 21.6901C16.6918 21.6901 15.6552 22.7267 15.6552 24.0053C15.6552 25.284 16.6918 26.3206 17.9704 26.3206C19.2491 26.3206 20.2856 25.284 20.2856 24.0053Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_3290_53405'
          x1='11.3597'
          y1='45.8936'
          x2='36.6403'
          y2='2.10636'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0845BF' />
          <stop
            offset='0.6'
            stopColor='#0B5CFF'
          />
          <stop
            offset='1'
            stopColor='#4F90EE'
          />
        </linearGradient>
        <clipPath id='clip0_3290_53405'>
          <rect
            width='48'
            height='48'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Zoom
